export const TOPICS_I18N_PREFIX = "features.topics.components.add_topic";

export const ADD_TOPIC_I18N_KEYS = {
  add_topic:                                  "add_topic",
  edit_topic:                                 "edit_topic",
  topic_name:                                 "topic_name",
  topic_name_missing_error:                   "topic_name_missing_error",
  topic_name_already_exists_error:            "topic_name_already_exists_error",
  topic_name_instructions:                    "topic_name_instructions",
  description:                                "description",
  description_instructions:                   "description_instructions",
  none_of_these_keywords:                     "none_of_these_keywords",
  any_of_these_keywords:                      "any_of_these_keywords",
  and_any_of_these_keywords:                  "and_any_of_these_keywords",
  press_comma_to_add_keywords:                "press_comma_to_add_keywords",
  topic_keywords_instructions:                "topic_keywords_instructions",
  exclude_keywords_instructions:              "exclude_keywords_instructions",
  categories:                                 "categories",
  categories_instructions:                    "categories_instructions",
  earliest_historical_data_date:              "earliest_historical_data_date",
  earliest_historical_data_date_error:        "earliest_historical_data_date_error",
  earliest_historical_data_date_instructions_part_1: "earliest_historical_data_date_instructions_part_1",
  earliest_historical_data_date_instructions_part_2: "earliest_historical_data_date_instructions_part_2",
  email_when_ready:                           "email_when_ready",
  email_when_ready_instructions:              "email_when_ready_instructions",
  asterisk_denotes_mandatory_field:           "asterisk_denotes_mandatory_field",
  cancel_button_text:                         "cancel_button_text",
  add_keyword_group_button_text:              "add_keyword_group_button_text",
  estimate_and_preview_button_text:           "estimate_and_preview_button_text",
  save_button_text:                           "save_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/AddTopici18nConstants.js